import React, { Component } from 'react';
import PropTypes from 'prop-types';

import FacebookShareButton from 'components/FacebookShareButton';
import TwitterShareButton from 'components/TwitterShareButton';
import EmailShareButton from 'components/EmailShareButton';
import CopyShareButton from 'components/CopyShareButton';

export default class ShareButtons extends Component {
  render() {
    const {
      user,
      twitterText,
      fbText,
      emailText,
      link,
      source,
      createAlert,
      circle,
    } = this.props;

    // TODO: Remove div in favor of React.Fragment
    return (
      <div>
        <FacebookShareButton
          user={ user }
          text={ fbText }
          source={ source }
          urlParams={ { ref: user ? user.username : null, pk_source: `fb`, pk_medium: `ref`, pk_content: source } }
          link={ link }
          circle={ circle }
        />
        <TwitterShareButton
          user={ user }
          text={ twitterText }
          source={ source }
          urlParams={{ ref: user ? user.username : null, pk_source: `twitter`, pk_medium: `ref`, pk_content: source } }
          link={ link }
          circle={ circle }
        />
        <EmailShareButton
          user={ user }
          text={ emailText }
          source={ source }
          urlParams={{ ref: user ? user.username : null, pk_source: `email`, pk_medium: `ref`, pk_content: source } }
          link={ link }
          circle={ circle }
        />
        <CopyShareButton
          user={ user }
          source={ source }
          link={ link }
          urlParams={{ ref: user ? user.username : null, pk_source: `copy`, pk_medium: `ref`, pk_content: source } }
          createAlert={ createAlert }
          circle={ circle }
        />
      </div>
    );
  }
}

ShareButtons.propTypes = {
  user: PropTypes.object,
  fbText: PropTypes.string.isRequired,
  twitterText: PropTypes.string.isRequired,
  emailText: PropTypes.string.isRequired,
  source: PropTypes.string.isRequired,
  createAlert: PropTypes.func.isRequired,
  link: PropTypes.string,
  circle: PropTypes.bool,
};
